import React from 'react';
import { motion } from 'framer-motion';
import { trackEvent } from './MetaPixel';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    const eventData = {
      content_name: 'El Arte de Crear Espacios Sagrados',
      content_type: 'product',
      content_ids: ['ebook-espacios-sagrados'],
      content_category: 'eBook',
      value: 7.99,
      currency: 'USD'
    };
    trackEvent('AddToCart', eventData);
    trackEvent('InitiateCheckout', eventData);
  };
  return <motion.a href="https://pay.hotmart.com/R104866725J" target="_blank" rel="noopener noreferrer" onClick={handleClick} className={`inline-block bg-gold-main text-white font-lora font-semibold text-lg md:text-xl py-4 px-8 rounded-sm shadow-md hover:shadow-lg transition-shadow text-center ${className}`} whileHover={{
    scale: 1.02,
    backgroundColor: '#D4AF37'
  }} whileTap={{
    scale: 0.98
  }} data-id="element-53">
      {children}
    </motion.a>;
}